<app-list2 listId="hira-predefined-view"
           (onSingleItemOperation)="onSingleItemOperation($event)">
</app-list2>
